module.exports = __webpack_public_path__ + "img/arrow-sidebar.6e53d1e2.svg";